import { useEffect, useRef } from "react";

import {
  clearRumUser,
  setRumUser,
  type RumUserContext,
} from "@/lib/observability-user";

// ADV-1319: keep the Dash0 RUM user + tenant context in sync with the auth
// session. Re-identifies whenever any identifying field changes (login, business
// switch, names resolving in from a query) and clears once on logout. The effect
// keys off a stable JSON serialization so a new-but-equal context object does not
// re-fire it. Idempotent against the Dash0 SDK; a no-op when RUM was never
// initialised (local dev without the ingest token).
export function useRumIdentity(context: RumUserContext | null): void {
  // Only clear on a real logout (identified → null), never on the initial
  // anonymous render before the session hydrates.
  const wasIdentified = useRef(false);
  const key = context ? JSON.stringify(context) : null;

  useEffect(() => {
    if (context) {
      setRumUser(context);
      wasIdentified.current = true;
    } else if (wasIdentified.current) {
      clearRumUser();
      wasIdentified.current = false;
    }
    // `key` is the stable dependency; `context` is read fresh inside.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
